export default __webpack_public_path__ + "static/media/nas_landscape_white_font.81b518b7.png";